import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function History({
  size = sizes.SMALL,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...props}
      style={{ width: size, height: size }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8.42993 3.73109H7.571C7.49243 3.73109 7.42815 3.79538 7.42815 3.87395V8.79002C7.42815 8.83645 7.44957 8.8793 7.48707 8.90609L10.4389 11.0614C10.5031 11.1079 10.5924 11.0954 10.6389 11.0311L11.1496 10.3347C11.1978 10.2686 11.1835 10.1793 11.1192 10.1347L8.57279 8.29359V3.87395C8.57279 3.79538 8.5085 3.73109 8.42993 3.73109ZM12.3549 5.07395L15.1549 5.75788C15.2442 5.7793 15.3317 5.71145 15.3317 5.62038L15.346 2.73645C15.346 2.6168 15.2085 2.54895 15.1156 2.62395L12.3014 4.82216C12.2801 4.83862 12.2639 4.86074 12.2546 4.88599C12.2454 4.91124 12.2434 4.93858 12.249 4.96489C12.2546 4.99119 12.2675 5.01538 12.2863 5.03467C12.305 5.05396 12.3288 5.06758 12.3549 5.07395ZM15.3496 10.4507L14.3371 10.1025C14.3018 10.0904 14.2631 10.0926 14.2294 10.1086C14.1957 10.1246 14.1696 10.1532 14.1567 10.1882C14.1228 10.2793 14.0871 10.3686 14.0496 10.4579C13.7317 11.2097 13.2764 11.8864 12.6942 12.4668C12.1185 13.0443 11.4363 13.5046 10.6853 13.8222C9.9073 14.1511 9.07102 14.3199 8.22636 14.3186C7.37279 14.3186 6.546 14.1525 5.76743 13.8222C5.01643 13.5046 4.33418 13.0443 3.7585 12.4668C3.17815 11.8864 2.72279 11.2097 2.40315 10.4579C2.07603 9.67945 1.90844 8.84331 1.91029 7.99895C1.91029 7.14538 2.07636 6.3168 2.40672 5.53823C2.72458 4.78645 3.17993 4.10966 3.76208 3.5293C4.33775 2.95184 5.02 2.49155 5.771 2.17395C6.546 1.84359 7.37458 1.67752 8.22815 1.67752C9.08172 1.67752 9.9085 1.84359 10.6871 2.17395C11.4381 2.49155 12.1203 2.95184 12.696 3.5293C12.8781 3.71323 13.0496 3.9043 13.2067 4.10609L14.2746 3.27038C12.8692 1.47395 10.6817 0.31859 8.22458 0.320376C3.946 0.322161 0.510289 3.79716 0.553146 8.07752C0.596003 12.2829 4.01565 15.6775 8.22815 15.6775C11.5406 15.6775 14.3621 13.5775 15.4371 10.6364C15.4639 10.5614 15.4246 10.4775 15.3496 10.4507Z"
        fill={colour}
      />
    </svg>
  )
}

History.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
